import React from 'react'
import moment from 'moment'
import RecordSection from './_RecordSection'
import InfoLine from './_InfoLine'
import { View, Text } from '@react-pdf/renderer'
import MedicalDrawing from './MedicalDrawing'
import { isHiddenEntryKey, pdfSafe } from '../../ePCR/liveCapture/liveUi'

const Assessment = ({ epcr }) => {
  return (
    <RecordSection title="Assessment">
      <Text
        style={{
          paddingVertical: 10,
          paddingHorizontal: 5,
          fontSize: 10,
          borderBottomStyle: 'solid',
          borderColor: '#F28B1F',
        }}
      >
        {epcr.assess.freeText}
      </Text>
      <View
        style={{
          // width: '100%',
          gap: 5,
          fontSize: 10,
          paddingHorizontal: 5,
          paddingVertical: 2,
        }}
      >
        {epcr.assess.modules.map((module, index) => (
          <View
            key={module.entryId ?? `${module.dateTime}-${index}`}
            rowGap={1}
            style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
          >
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%',
                fontSize: 10,
                borderTop: index === 0 ? null : 'solid',
                borderColor: '#616161',
                padding: 5,
              }}
            >
              <View>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>
                  {module.moduleName}
                </Text>
              </View>
              <View>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>
                  {moment(module.dateTime).format('HH:mm')}
                </Text>
              </View>
            </View>
            <Text style={{ paddingHorizontal: 5 }}>{module['Assessment']}</Text>
            <View
              style={{
                // width: '100%',
                display: 'flex',
                flexWrap: 'wrap',
                columnGap: 5,
                rowGap: 1,
                padding: 5,
              }}
            >
              {Object.keys(module)
                .filter(
                  (x) =>
                    !isHiddenEntryKey(x, [
                      'dateTime',
                      'moduleName',
                      'Assessment',
                      'Image',
                      'awsMedicalDrawing',
                      'imagingRequestId',
                    ]),
                )
                .map((x) => (
                  <InfoLine
                    key={x}
                    label={pdfSafe(x)}
                    value={pdfSafe(
                      Array.isArray(module[x])
                        ? module[x].join(', ')
                        : module[x],
                    )}
                  />
                ))}
            </View>
            {module.awsMedicalDrawing && (
              <MedicalDrawing imageKey={module.awsMedicalDrawing} />
            )}
          </View>
        ))}
      </View>
    </RecordSection>
  )
}

export default Assessment
